import { render } from "./ReviewTabs.vue?vue&type=template&id=68ace857&scoped=true"
import script from "./ReviewTabs.vue?vue&type=script&lang=js"
export * from "./ReviewTabs.vue?vue&type=script&lang=js"

import "./ReviewTabs.vue?vue&type=style&index=0&id=68ace857&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68ace857"]])

export default __exports__